/* unplugin-vue-components disabled */import { render } from "./monitorFrame.vue?vue&type=template&id=2cc5f101"
import script from "./monitorFrame.vue?vue&type=script&lang=js"
export * from "./monitorFrame.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__